import { useTranslation } from 'react-i18next';
import { Outlet, NavLink } from 'react-router-dom';
import Dropdown from '../ui/Dropdown';
import Banner from '../ui/Banner';
import { CircleFlag } from 'react-circle-flags';
import { Trans } from '../i18n';

const AuthLayout = () => {
	const { i18n, t } = useTranslation();

	const handleLanguageChange = (language) => {
		i18n.changeLanguage(language);
	};

	const languageOptions = [
		{ label: 'English', value: 'en', icon: <CircleFlag countryCode='uk' style={{ height: '24px' }} /> },
		{ label: 'Svenska', value: 'sv', icon: <CircleFlag countryCode='se' style={{ height: '24px' }} /> },
	];

	return (
		<div className='flex flex-col min-h-screen'>
			<div className='flex flex-col justify-center flex-1'>
				<div className='flex flex-1 flex-row'>
					<div className="flex flex-col py-6 px-8 w-1/2 bg-cover bg-center bg-[url('/images/login-bg.png')]">
						<div className='flex flex-col justify-start items-start'>
							<NavLink to='/'>
								<img src='/images/logo.svg' alt='infosoc logo' className='h-8' />
							</NavLink>
						</div>
						<div className='flex flex-1 flex-col gap-6 p-16 justify-center'>
							<h1 className='text-5xl font-medium max-w-3xl'>
								<Trans i18nKey='login.left_title' values={{ app_name: t('general.app_name') }} />
							</h1>
							<h2 className='text-2xl max-w-3xl'>
								<Trans i18nKey='login.left_description' values={{ app_name: t('general.app_name') }} />
							</h2>
						</div>
						<Banner label={<Trans i18nKey='login.notice' />} variant='alpha' />
					</div>
					<div className='flex flex-col py-6 px-8 w-1/2'>
						<div className='flex flex-row justify-between items-center'>
							<div className='flex flex-col'>
								<div>
									<img
										src='/images/Socrates_textlogo_tagline.png'
										alt='Socrates logo'
										className='h-10'
									/>
								</div>
							</div>
							<div className='flex items-center'>
								<Dropdown
									options={languageOptions}
									onChange={handleLanguageChange}
									value={i18n.language}
									placeholder={'Language'}
								/>
							</div>
						</div>
						<div className='flex flex-col flex-1'>
							<Outlet />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AuthLayout;
